module.exports = __webpack_public_path__ + "static/013.thumb-9e1c4f14411980e77a4b2a8a213eccb2.jpg";